import { createFileRoute } from '@tanstack/react-router';
import { CardDetailsPage } from '../components/pages/CardPage/CardDetailsPage';

export const Route = createFileRoute('/account/cards_/$cardId_/details')({
  component: CardDetailsPage,
});
